module.exports = __webpack_public_path__ + "static/media/deliveredSuccess.fd35520e.svg";